<template>
    <div style="background:#fff; padding:20px;">
        <!-- 顶部搜索条 -->
        <div style="margin-bottom: 20px">
            <a-input
                v-model="queryParam.nickname"
                placeholder="请输入昵称/展示名"
                style="width: 180px; margin-right: 10px"
                allow-clear
            />
            <a-input
                v-model="queryParam.phone"
                placeholder="请输入手机号"
                style="width: 180px; margin-right: 10px"
                allow-clear
            />
            <a-select
                v-model="queryParam.roleType"
                placeholder="角色类型"
                style="width: 140px; margin-right: 10px"
                allow-clear
            >
                <a-select-option :value="0">普通</a-select-option>
                <a-select-option :value="1">商家</a-select-option>
                <a-select-option :value="2">师傅</a-select-option>
                <a-select-option :value="3">双角色</a-select-option>
            </a-select>
            <a-select
                v-model="queryParam.status"
                placeholder="状态"
                style="width: 120px; margin-right: 10px"
                allow-clear
            >
                <a-select-option :value="1">启用</a-select-option>
                <a-select-option :value="0">禁用</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 10px" icon="reload" @click="handleReset">重置</a-button>
        </div>

        <!-- 用户列表 -->
        <a-table
            :columns="columns"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            :scroll="{ x: 1750 }"
            rowKey="id"
            @change="handleTableChange"
        >
            <!-- 角色类型 -->
            <span slot="roleType" slot-scope="text">
                <a-tag v-if="text === 0">普通</a-tag>
                <a-tag v-else-if="text === 1" color="blue">商家</a-tag>
                <a-tag v-else-if="text === 2" color="orange">师傅</a-tag>
                <a-tag v-else-if="text === 3" color="purple">双角色</a-tag>
                <a-tag v-else>未知</a-tag>
            </span>

            <!-- 状态 -->
            <span slot="status" slot-scope="text">
                <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '禁用' }}</a-tag>
            </span>

            <!-- 会员状态 -->
            <span slot="member" slot-scope="text, record">
                <a-tag v-if="text" color="green">会员有效</a-tag>
                <a-tag v-else-if="record.memberExpireAt" color="orange">已过期</a-tag>
                <a-tag v-else>未开通</a-tag>
            </span>

            <!-- 会员时间 -->
            <span slot="memberRechargeAt" slot-scope="text">{{ formatDateTime(text) }}</span>
            <span slot="memberExpireAt" slot-scope="text">{{ formatDateTime(text) }}</span>

            <!-- 操作列 -->
            <span slot="action" slot-scope="text, record">
                <a @click="openGrantMembership(record)">增加会员</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    v-if="record.status === 1"
                    title="确定要禁用该用户吗?"
                    @confirm="handleToggleStatus(record)"
                >
                    <a style="color: red">禁用</a>
                </a-popconfirm>
                <a-popconfirm
                    v-else
                    title="确定要启用该用户吗?"
                    @confirm="handleToggleStatus(record)"
                >
                    <a style="color: #1890ff">启用</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定要删除该用户吗?"
                    @confirm="handleDelete(record)"
                >
                    <a style="color: red">删除</a>
                </a-popconfirm>
            </span>
        </a-table>

        <a-modal
            v-model="membershipVisible"
            title="增加会员天数"
            :confirm-loading="membershipSubmitting"
            @ok="submitGrantMembership"
            @cancel="closeGrantMembership"
        >
            <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item label="指定用户">
                    <span>{{ membershipForm.displayName || '-' }}（ID：{{ membershipForm.userId || '-' }}）</span>
                </a-form-model-item>
                <a-form-model-item label="增加天数" required>
                    <a-input-number
                        v-model="membershipForm.days"
                        :min="1"
                        :max="3650"
                        :precision="0"
                        style="width: 100%"
                    />
                </a-form-model-item>
                <a-alert
                    type="info"
                    show-icon
                    message="有效会员从当前到期时间顺延；已过期或未开通用户从现在开始计算。"
                />
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import { deleteAppUser, getAppUserList, grantAppUserMembershipDays, toggleAppUserStatus } from '@/api'
import { retreatPageAfterDelete } from '@/utils/pagination'

export default {
    data() {
        return {
            // 查询条件
            queryParam: {
                nickname: '',
                phone: '',
                roleType: undefined,
                status: undefined
            },
            data: [],
            loading: false,
            membershipVisible: false,
            membershipSubmitting: false,
            membershipForm: {
                userId: undefined,
                displayName: '',
                days: 30
            },
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: (total) => `共 ${total} 条`
            },
            columns: [
                { title: 'ID', dataIndex: 'id', width: 80 },
                { title: '昵称', dataIndex: 'nickname' },
                { title: '商家名称', dataIndex: 'merchantName' },
                { title: '师傅实名', dataIndex: 'realName' },
                { title: '展示名称', dataIndex: 'displayName' },
                { title: '手机号', dataIndex: 'phone' },
                {
                    title: '角色类型',
                    dataIndex: 'roleType',
                    scopedSlots: { customRender: 'roleType' }
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' }
                },
                { title: '余额', dataIndex: 'balance' },
                {
                    title: '会员状态',
                    dataIndex: 'member',
                    width: 100,
                    scopedSlots: { customRender: 'member' }
                },
                {
                    title: '最近充值时间',
                    dataIndex: 'memberRechargeAt',
                    width: 170,
                    scopedSlots: { customRender: 'memberRechargeAt' }
                },
                {
                    title: '会员到期时间',
                    dataIndex: 'memberExpireAt',
                    width: 170,
                    scopedSlots: { customRender: 'memberExpireAt' }
                },
                { title: '注册时间', dataIndex: 'createdAt' },
                {
                    title: '操作',
                    key: 'action',
                    width: 230,
                    scopedSlots: { customRender: 'action' }
                }
            ]
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        // 统一格式化后端 LocalDateTime，空值显示占位符
        formatDateTime(value) {
            if (!value) return '-'
            return String(value).replace('T', ' ').substring(0, 19)
        },
        // 加载列表数据
        loadData() {
            this.loading = true
            const params = {
                page: this.pagination.current,
                pageSize: this.pagination.pageSize,
                nickname: this.queryParam.nickname || undefined,
                phone: this.queryParam.phone || undefined,
                roleType: this.queryParam.roleType,
                status: this.queryParam.status
            }
            getAppUserList(params).then(res => {
                const payload = res.data || {}
                this.data = payload.list || []
                this.pagination.total = payload.total || 0
            }).catch(err => {
                this.$message.error(err && err.message ? err.message : '加载失败')
            }).finally(() => {
                this.loading = false
            })
        },
        // 查询按钮：重置到第一页
        handleSearch() {
            this.pagination.current = 1
            this.loadData()
        },
        // 重置按钮：清空查询条件
        handleReset() {
            this.queryParam = {
                nickname: '',
                phone: '',
                roleType: undefined,
                status: undefined
            }
            this.pagination.current = 1
            this.loadData()
        },
        // 翻页
        handleTableChange(pagination) {
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.loadData()
        },
        // 打开指定用户的会员天数添加弹窗
        openGrantMembership(record) {
            this.membershipForm = {
                userId: record.id,
                displayName: record.displayName || record.nickname || '',
                days: 30
            }
            this.membershipVisible = true
        },
        closeGrantMembership() {
            if (this.membershipSubmitting) return
            this.membershipVisible = false
        },
        submitGrantMembership() {
            const days = Number(this.membershipForm.days)
            if (!Number.isInteger(days) || days < 1 || days > 3650) {
                this.$message.error('会员天数必须在1到3650天之间')
                return
            }
            this.membershipSubmitting = true
            grantAppUserMembershipDays(this.membershipForm.userId, { days }).then(() => {
                this.$message.success('会员天数添加成功')
                this.membershipVisible = false
                this.loadData()
            }).catch(err => {
                this.$message.error(err && err.message ? err.message : '添加失败')
            }).finally(() => {
                this.membershipSubmitting = false
            })
        },
        // 切换启用 / 禁用状态
        handleToggleStatus(record) {
            const nextStatus = record.status === 1 ? 0 : 1
            toggleAppUserStatus(record.id, { status: nextStatus }).then(() => {
                this.$message.success(nextStatus === 1 ? '启用成功' : '禁用成功')
                this.loadData()
            }).catch(err => {
                this.$message.error(err && err.message ? err.message : '操作失败')
            })
        },
        // 删除小程序用户
        handleDelete(record) {
            deleteAppUser(record.id).then(() => {
                this.$message.success('删除成功')
                retreatPageAfterDelete(this.pagination, this.data.length)
                this.loadData()
            }).catch(err => {
                this.$message.error(err && err.message ? err.message : '删除失败')
            })
        }
    }
}
</script>
